<template>
  <van-tabbar
    v-model="active"
    inactive-color="#777777"
    active-color="#000000"
    style="z-index: 9999"
  >
    <van-tabbar-item
      v-for="(item, index) in tabbars"
      :key="index"
      @click="tabbarClick(index)"
      :info="index == 3 ? (num == '' ? '' : num) : ''"
    >
      <div v-if="index == 1" class="new_fiex">
        <img src="../../static/image/jr-icon-add.png" alt="" />
      </div>
      <span v-if="index != 3" :class="index === indexNum ? 'active' : ''">{{ item.title }}</span>
      <img v-if="index != 3" slot="icon" :src="index === indexNum ? item.active : item.normal" />
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: 'TabBarView',
  data() {
    return {
      active: 0,
      num: this.$store.state.unReadCound,
      tabbars: [
        {
          name: 'works',
          title: this.$t('message.home.work_conTwo'),
          normal:
            'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/jr-icon-community(1).png',
          active:
            'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/jr-icon-three(1).png'
        },
        {
          name: 'contribution',
          title: this.$t('message.home.contribute')
        },
        {
          name: 'index',
          title: this.$t('message.home.IntroductionTwo'),
          normal:
            'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/jr-icon-five(1).png',
          active:
            'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/jr-icon-gift(1).png'
        }
      ]
    }
  },
  props: {
    indexNum: {
      type: Number
    }
  },
  watch: {
    getunReadCound(val) {
      if (val == 0) {
        this.num = ''
      } else {
        this.num = val
      }
    }
  },
  methods: {
    tabbarClick(index) {
      this.$emit('tabBarClick', index)
    }
  }
}
</script>

<style scoped lang="less">
.new_fiex {
  width: 42px;
  height: 42px;
  margin-top: -50px;
  margin-bottom: 8px;
  z-index: 100000;

  img {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    width: 42px;
    height: 42px;
    margin-left: 4px;
  }
}

.active {
  color: #3562ff;
}

[class*='van-hairline']::after {
  border: none !important;
}
</style>
